import i18n from "@/i18n";

export default {
  headers: [
    {
      text: i18n.t("crudCenter.hImage"),
      value: "imageBase64",
      sortable: false,
    },
    {
      text: i18n.t("crudCenter.hCenterName"),
      value: "name",
      sortable: true,
    },
    {
      text: i18n.t("crudCenter.hCenterPhoneNumber"),
      value: "phoneNumber",
      sortable: true,
    },
    {
      text: i18n.t("crudRooms.hPartialCap"),
      value: "partialCap",
      sortable: true,
    },
    {
      text: i18n.t("crudCenter.hActions"),
      value: "actions",
      align: "center",
      sortable: false,
    },
  ],
  locale: {
    title: i18n.t("crudCenter.title"),
    search: i18n.t("crudCenter.searchCenter"),
    deleteConfirm: i18n.t("crudCenter.confirmDelete"),
    newItem: i18n.t("crudCenter.newCenter"),
    updateItem: i18n.t("crudCenter.updateCenter"),
  },
};
